const routes = [{
  path: '/',
  component: () => import('@/views/home/index.vue'),
  meta: { title: '首页', skipLoginCheck: true }
}, {
  path: '/zh-tw',
  component: () => import('@/views/home/index.vue'),
  meta: { skipLoginCheck: true }
}, {
  path: '/en',
  component: () => import('@/views/home/index.vue'),
  meta: { skipLoginCheck: true }
}, {
  path: '/ja',
  component: () => import('@/views/home/index.vue'),
  meta: { skipLoginCheck: true }
}, {
  path: '/ko',
  component: () => import('@/views/home/index.vue'),
  meta: { skipLoginCheck: true }
}, {
  path: '/home',
  name: 'Home',
  component: () => import('@/views/home/index.vue'),
  meta: { title: '首页', skipLoginCheck: true }
}, {
  path: '/terms',
  name: 'Terms',
  component: () => import('@/views/terms/index.vue'),
  meta: { title: '使用条款', skipLoginCheck: true }
}, {
  path: '/ja-terms',
  name: 'JaTerms',
  component: () => import('@/views/terms/ja.vue'),
  meta: { title: '使用条款-日语', skipLoginCheck: true }
}, {
  path: '/ja-personal',
  name: 'JaPersonal',
  component: () => import('@/views/personal/ja.vue'),
  meta: { title: '同意书', skipLoginCheck: true }
}, {
  path: '/login',
  name: 'Login',
  component: () => import('@/views/login/login.vue'),
  meta: { title: '登录', skipLoginCheck: true }
}, {
  path: '/forgot-password',
  name: 'ForgotPassword',
  component: () => import('@/views/login/forgot-password.vue'),
  meta: { title: '忘记密码', skipLoginCheck: true }
}, {
  path: '/reset-password',
  name: 'ResetPassword',
  component: () => import('@/views/login/reset-password.vue'),
  meta: { title: '重置密码', skipLoginCheck: true }
}, {
  path: '/reconfirm-email',
  name: 'ReconfirmEmail',
  component: () => import('@/views/login/reconfirm-email.vue'),
  meta: { title: '确认邮件', skipLoginCheck: true }
}, {
  path: '/product-media',
  name: 'ProductMedia',
  component: () => import('@/views/promotion/product-media.vue'),
  meta: { title: '商品列表', skipLoginCheck: true, hideFooterLayout: true }
}, {
  path: '/signup',
  name: 'Signup',
  component: {
    render(c) { return c('router-view') }
  },
  redirect: {
    name: 'SignupAffiliate'
  },
  children: [{
    path: 'affiliate',
    name: 'SignupAffiliate',
    component: () => import('@/views/signup/index.vue'),
    meta: { title: '注册', skipLoginCheck: true }
  },{
    path: 'step1',
    name: 'SignupStep1',
    component: () => import('@/views/signup/step1.vue'),
    meta: { title: '注册-你的帳號資訊', skipLoginCheck: true, keepAlive: true }
  }, {
    path: 'step2',
    name: 'SignupStep2',
    component: () => import('@/views/signup/step2.vue'),
    meta: { title: '注册-你的帳號資訊', skipLoginCheck: true, keepAlive: true }
  }, {
    path: 'step3',
    name: 'SignupStep3',
    component: () => import('@/views/signup/step3.vue'),
    meta: { title: '注册-你的帳號資訊', skipLoginCheck: true, keepAlive: true }
  }, {
    path: 'verify',
    name: 'Verify',
    component: () => import('@/views/signup/verify.vue'),
    meta: { title: '確認', skipLoginCheck: true }
  }]
}
]

export default routes
